export class RestReportBean {
  constructor() {
    this.reportName = "";
    this.reportFileID = "";
    this.reportType = 0;
    this.reportFilePath = "";
  }
}
export class TableColumnDef {
  constructor() {
    this.header = "";
    this.accessor = "";
    this.sortable = false;
    this.isHyperLink = false;
    this.clickHandler = null;
  }
}

export class ReportBean {
  constructor() {
	this.reportName = "";
	this.reportFileID = "";
	this.reportType = 0;
	this.reportFilePath = "";
  }
}